// extracted by mini-css-extract-plugin
module.exports = {"_frame":"FragenUndAntworten__frame__12Jdu"};